var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.correoFaltante || _vm.telefonoFaltante)?_c('v-alert',{attrs:{"type":"warning","dense":"","outlined":"","icon":"mdi-alert-circle"}},[_vm._v(" Este personal tiene datos de contacto pendientes de completar: "),_c('strong',[_vm._v(_vm._s(_vm.mensajeCampos))]),_vm._v(". Algunas operaciones podrían fallar hasta que se actualicen. ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }